package com.essntl.features.task.domain.model

import kotlinx.datetime.*

data class TaskFilterOptions(
    val dueDate: LocalDate = Clock.System.now().toLocalDateTime(TimeZone.UTC).date,
    val monday: LocalDate = Clock.System.now().toLocalDateTime(TimeZone.UTC).date.minus(
        Clock.System.now().toLocalDateTime(TimeZone.UTC).date.dayOfWeek.ordinal.toLong(),
        DateTimeUnit.DAY,
    ),
    val weeklyTasks: Boolean = false,
    val selectedProfileIds: Set<String> = emptySet(),
    val selectedTaskStatus: Set<String> = emptySet(),
) {
    val weekDatesRange
        get() = run {
            val datesRange: ArrayList<String> = ArrayList()
            for (i in 0 until 7) {
                val nextDay = monday.plus(DatePeriod(days = i))
                datesRange.add(nextDay.toString())
            }
            datesRange
        }
}